import { __ } from '../functions/commom';
import InputBox from './base/InputBox';
import { ReactComponent as CouponIcon } from '../assets/icons/coupon.svg';
import Button from './base/Button';
import { createUseStyles } from 'react-jss';
import { useAppState } from '../state/StateContext';
import { useState } from 'react';
import { couponCodeValidate } from '../functions/insuranceSearchService';

const useStyles = createUseStyles({
  couponCodeInput: {},
  couponCodeApplyButton: {
    border: 0,
    borderRadius: 0,
    color: '#ffffff',
    backgroundColor: 'var(--dai-primary-color)',
    fontSize: '14px',
    minHeight: '42px',
    '&.applied': {
      backgroundColor: '#cccccc',
    },
  },
  couponCodeApplied: {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '5px',
    fontSize: '14px !important',
    fontWeight: 'bold',
    marginTop: '10px',
    backgroundColor: 'var(--dai-primary-color)',
    color: '#ffffff',
    padding: '8px',
    borderRadius: '5px',
    '& svg': {
      width: '12px',
      height: '12px',
      fill: '#ffffff',
    },
  },
});

const CouponCodeInput: React.FC = () => {
  const classes = useStyles();
  const state = useAppState();

  const [applied, setApplied] = useState(false);

  const [errors, setErrors] = useState<
    Array<{ field: string; message: string }>
  >([]);

  const [couponCode, setCouponCode] = useState<string | undefined>(undefined);

  const handleApplyCouponCode = async () => {
    setApplied(false);
    setErrors([]);

    if (!couponCode) {
      setErrors([
        { field: 'couponCode', message: __('Please enter a coupon code') },
      ]);
      return;
    }

    try {
      const result = await couponCodeValidate(couponCode);

      if (!result.valid) {
        setErrors([
          { field: 'couponCode', message: __('Invalid coupon code') },
        ]);
        console.log('invalid coupon code');
        return;
      }

      setApplied(true);
    } catch (error) {
      setErrors([{ field: 'couponCode', message: __('Invalid coupon code') }]);
      return;
    }

    // if valid, set the coupon code to the state
    state?.searchForm?.couponCode?.set(couponCode);
  };

  const handleCouponCodeStateChange = (value: string | undefined) => {
    if (applied) {
      setApplied(false);
      state?.searchForm?.couponCode?.set(undefined);
    }
    setCouponCode(value || '');
  };

  return (
    <>
      <div className={classes.couponCodeInput}>
        <InputBox
          placeholder={__('Coupon Code') + ' ' + __('(If applicable)')}
          value={couponCode}
          onChange={handleCouponCodeStateChange}
          icon={<CouponIcon />}
          iconPosition="before"
          errorMessage={
            errors.find((error) => error.field === 'couponCode')?.message
          }
          actionButton={
            <Button
              className={
                classes.couponCodeApplyButton + (applied ? ' applied' : '')
              }
              onClick={handleApplyCouponCode}
            >
              {applied ? __('Applied') : __('Apply')}
            </Button>
          }
        />
      </div>
    </>
  );
};

export default CouponCodeInput;
